import React from 'react'
import { VideoRoom } from "./components/VideoRoom"
import { OpenViduProvider } from "./contexts"
import { Alert } from './components/Alert'

export const App = () => {
  return <OpenViduProvider>
    <Alert />
    <VideoRoom />
  </OpenViduProvider>
}